const brands = ["Volkswagen", "Audi", "Škoda", "SEAT", "Cupra", "VAG Group"];
const engines = ["EA888 Gen3", "2.0 TSI", "1.8 TSI", "MQB Platform", "MLB Evo", "EA888 Gen2"];

export default function ApplicationsStrip() {
  // duplicate for seamless marquee
  const items = [...brands, ...engines, ...brands, ...engines];

  return (
    <section
      data-testid="applications-strip"
      className="relative py-8 border-y border-[#C8D3DF] bg-[#F4F6FA] overflow-hidden"
    >
      <div className="absolute inset-0 dotted-bg opacity-30 pointer-events-none" />
      <div className="flex items-center gap-6 relative">
        <div className="hidden md:flex items-center gap-2 pl-6 lg:pl-12 shrink-0 z-10 bg-[#F4F6FA] pr-6 border-r border-[#C8D3DF]">
          <span className="w-2 h-2 bg-[#5B9BD5]" />
          <span className="font-mono text-[10px] tracking-[0.3em] text-[#536073] uppercase">
            Confirmed Fitments
          </span>
        </div>

        <div className="marquee-track animate-marquee">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-10 mr-10 shrink-0">
              <span className="font-chivo font-black text-2xl lg:text-3xl text-[#1A2232] tracking-tighter whitespace-nowrap">
                {it}
              </span>
              <span className="text-[#5B9BD5] font-mono text-xl">×</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
